<template>
  <v-layout column class="pagemargin page">
    <v-layout row wrap>
      <v-flex md12 class="select-container">
        <v-card>
          <v-toolbar color="secondary">
            <v-toolbar-title class="report-title font-weight-thin white--text">
              Dashboard for
              <strong>{{gName}}</strong> on
              <strong>{{ formatDate(gDate, "YYYY-MM-DD", "DD-MMM-YY") }}</strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-select
              v-model="selected"
              :items="games"
              item-text="gameName"
              item-value="id"
              attach
              label="Change game"
              dark
              class="font-weight-thin"
              @input="selectGame(selected)"
            >
              <template
                slot="selection"
                slot-scope="data"
              >{{ data.item.gameName }} on {{ formatDate(data.item.date, "YYYY-MM-DD", "DD-MMM-YY") }}</template>
              <template slot="item" slot-scope="data">
                <template><span style="font-weight: bold">{{ data.item.gameName }} </span> &nbsp; on &nbsp; <span style="font-weight: bold">{{ formatDate(data.item.date, "YYYY-MM-DD", "DD-MMM-YY") }}</span></template>
              </template>
            </v-select>
          </v-toolbar>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="mt-3 pa-3">
      <!--v-flex xs12>
        No of Games => {{ games.length }} <br />
        LatestGame => <pre align="left">{{ latestGame }}</pre>
      </v-flex-->
      <v-flex xs12 md3>
        <h3>Top 5 Sponsors by Air Time</h3>
        <v-divider style="margin: 0px 20px 0px 20px !important" />
        <SponsorsByAirTime />
      </v-flex>
      <v-flex xs12 md3>
        <h3>Top 5 Locations by Air Time</h3>
        <v-divider style="margin: 0px 20px 0px 20px !important" />
        <LocationsByAirTime />
      </v-flex>
      <v-flex xs12 md3>
        <h3>Top 5 by Ad Frequency</h3>
        <v-divider style="margin: 0px 20px 0px 20px !important" />
        <SponsorsByAdFrequency />
      </v-flex>
      <v-flex xs12 md3>
        <h3>Top 5 Sponsors by Dwell Time</h3>
        <v-divider style="margin: 0px 20px 0px 20px !important" />
        <SponsorsByDwellTime />
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import SponsorsByDwellTime from "@/components/charts/SponsorsByDwellTime.vue";
import LocationsByAirTime from "@/components/charts/LocationsByAirTime.vue";
import SponsorsByAdFrequency from "@/components/charts/SponsorsByAdFrequency.vue";
import SponsorsByAirTime from "@/components/charts/SponsorsByAirTime.vue";
import { mapState } from "vuex";
export default {
  name: "Chart",
  components: {
    SponsorsByDwellTime,
    LocationsByAirTime,
    SponsorsByAdFrequency,
    SponsorsByAirTime
  },
  data() {
    return {
      active: null,
      games: [],
      latestGame: {},
      portalList: [],
      hiddenSelect: false,
      hiddenAnalysis: false,
      selected: ""
    };
  },
  computed: {
    ...mapState({
      portal: state => state.portal,
      Portals: state => state.Admin.Portals,
      Documents: state => state.Admin.Documents,
      gameID: state => state.game.gameID,
      gName: state => state.report.gameName,
      gDate: state => state.report.gameDate,
      gID: state => state.report.gameID
    })
    /*
    latestGame() {
      console.log("computed - latestGame")
      if (this.games != undefined) {
        return this.$sortBy(this.games, 'date').reverse().slice(0,1);
      } else {
        return null
      }
    }*/
  },
  watch: {
    portal: {
      handler: function() {
        this.readGames();
      },
      deep: true
    },
    Portals: {
      handler: function() {
        this.portalList = this.Portals;
      },
      deep: true
    },
    Documents: {
      handler: function() {
        this.games = this.Documents;
      },
      deep: true
    },
    DocumentResult: {
      handler: function() {
        this.readGames();
      },
      deep: true
    },
    games: {
      handler: function() {
        console.log("watch => games (updated)");
        var games = this.games;
        if (games != undefined) {
          this.latestGame = this.$sortBy(games, "date")
            .reverse()
            .slice(0, 1)[0];
        }
      },
      deep: true
    },
    latestGame: {
      handler: function() {
        console.log("watch => latestGame has updated");
        console.log("set gameID = " + this.latestGame.id);
        this.$store.commit("report/setValue", ["gameID", this.latestGame.id]);
        this.$store.commit("report/setValue", [
          "gameName",
          this.latestGame.gameName
        ]);
        this.$store.commit("report/setValue", [
          "gameDate",
          this.latestGame.date
        ]);
        this.$store.dispatch("clip/getClipsByStatusAndGame", [
          "clips",
          this.portal.active.id,
          this.latestGame.id,
          "Draft",
          "clip/setSponByGameResult"
        ]);
      },
      deep: true
    }
  },
  methods: {
    readGames() {
      this.$store.commit("clip/setSponByGameResultEmpty");

      this.$store.dispatch("Admin/readDocuments", [
        "games",
        this.portal.active.id,
        "Admin/setDocuments"
      ]);
    },
    formatDate: function(value, formatIn, formatOut) {
      return this.$moment(value, formatIn).format(formatOut);
    },

    // sortGamesByDate() {
    //   this.games.sort(function(a, b) {
    //     var dateA = new Date(a.date);
    //     var dateB = new Date(b.date);
    //     return dateB - dateA;
    //   });
    // },
    selectGame(gameID) {
      // // console.log("Selected: " + gameID);
      this.$store.commit("report/setValue", ["gameID", gameID]);
      this.$store.dispatch("Admin/readDocumentByID", [
        "games",
        this.gID,
        "Admin/setDocByID"
      ]);
      var i = 0;
      var gameName = "";
      var gameDate = "";
      for (i = 0; i < this.Documents.length; i++) {
        if (gameID === this.Documents[i].id) {
          gameName = this.Documents[i].gameName;
          gameDate = this.Documents[i].date;
          this.$store.commit("report/setValue", ["gameName", gameName]);
          this.$store.commit("report/setValue", ["gameDate", gameDate]);
        }
      }
      console.log("GAME DATE: " + gameDate);
      //update table on select
      this.$store.dispatch("clip/getClipsByStatusAndGame", [
        "clips",
        this.portal.active.id,
        this.gID,
        "Draft",
        "clip/setSponByGameResult"
      ]);
    },
    initializePage() {
      this.readGames();

      //this.sortGamesByDate();
      //var docs = this.games;
      //var i = 0;
      //for (i = 0; i < this.Documents.length; i++) {
      //  docs.push(this.Documents[i]);
      //}
      //
      //if (docs[0] !== undefined) {
      //  this.$store.commit("report/setValue", ["gameID", docs[0].id]);
      //  this.$store.commit("report/setValue", ["gameName", docs[0].gameName]);
      //}
    }
  },
  mounted() {
    this.initializePage();
    this.readGames();
    this.$store.dispatch("portal/readLookups", [
      "lookups",
      this.portal.active.id,
      "portal/setLookups",
      "portal/setLookupsResult"
    ]);
  }
};
</script>

<style>
.select-container {
  position: relative;
  z-index: 2;
  margin-top: 0px !important;
}
</style>